// extracted by mini-css-extract-plugin
export default {"col":"index_col_XTAaW","mt36":"index_mt36_2HBXK","box":"index_box_IsksU","left":"index_left_WFlrT index_box_IsksU","right":"index_right_hVkcg index_box_IsksU"};